import { FeatureModel } from '@tailormap-viewer/api';

export interface FeatureInfoFeatureModel extends FeatureModel {
  layerId: string;
}
